module.exports = __webpack_public_path__ + "img/parter_avatar00.948f2ec1.png";